import { isWebPlatform, Platform } from '@eventbrite/checkout-postmessage-api';
import { replace } from 'react-router-redux';
import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { updateOrderAction } from '../';
import {
    SURVEY_EXPANSION,
    SURVEY_RESPONSES_EXPANSION,
} from '../../../api/constants';
import { getOrder, getOrderAttendees } from '../../../api/order';
import { getExistingOrderId } from '../../../selectors/app';
import { getSurvey } from '../../../selectors/survey';
import { CheckoutState } from '../../../state';
import { getOrganizerQuestionsPage } from '../../../utils/routes';
import {
    notifyParentOrderComplete,
    notifyParentOrderStatusPlaced,
} from '../../notifyParent';
import { showPurchaseConfirmation } from '../../purchaseConfirmation';
import {
    getInitSurveysActionFromOrderResponse,
    prefillPreTicketsOrganizerQuestionsForm,
} from '../../survey';

export const getExistingOrderData =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const existingOrderId = getExistingOrderId(getState());

        if (!existingOrderId) {
            return;
        }

        try {
            const [{ response: orderResponse }, attendees] = await Promise.all([
                getOrder(existingOrderId),
                getOrderAttendees(
                    existingOrderId,
                    `${SURVEY_EXPANSION},${SURVEY_RESPONSES_EXPANSION}`,
                ),
            ]);

            const response = {
                ...orderResponse,
                attendees,
            };

            dispatch(getInitSurveysActionFromOrderResponse(response));
            dispatch(updateOrderAction(response));
            dispatch(prefillPreTicketsOrganizerQuestionsForm());
        } catch (error) {
            // TODO: EB-229798 - Error handling. Communicate with my order to display there the error message (postMessage)
        }
    };

export const completeOrderActions =
    (): ThunkAction<void, CheckoutState, void> => (dispatch) => {
        dispatch(notifyParentOrderComplete());
    };

export const goToPageAfterOrderSuccessAnimations =
    () =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        const {
            preOrderConfirmationSurveySettings: {
                hasQuestions: isOrderFormInTwoPages,
            },
        } = getSurvey(getState());

        if (isOrderFormInTwoPages) {
            dispatch(replace(getOrganizerQuestionsPage()));
        } else {
            const platform = dispatch(
                notifyParentOrderStatusPlaced(),
            ) as Platform;

            if (isWebPlatform(platform)) {
                await dispatch(showPurchaseConfirmation());
            }
        }
    };
